import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTileView = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#2B2B2B",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 8.167,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 15.833,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.167,
				y: .5,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.167,
				y: 8.167,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.167,
				y: 15.833,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 15.833,
				y: .5,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 15.833,
				y: 8.167,
				width: 5.708,
				height: 5.708,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 15.833,
				y: 15.833,
				width: 5.708,
				height: 5.708,
				rx: 1
			})
		]
	})
});
export default SvgTileView;
